<template>
	<BaseCmsPage @load="onPageLoad">
		<CmsCheckoutWrapper>
			<WebshopCheckout>
				<ClientOnly>
					<BaseWebshopCart v-slot="{cart}">
						<form @submit.prevent="onSubmit" v-if="cart">
							<div class="wc-form wc-form-shipping floating-labels">
								<div class="wc-form-col1">
									<ClientOnly>
										<WebshopHelloBar />
									</ClientOnly>
									<WebshopSteps :step="2" />

									<div v-if="shippingLeanpayError" class="unavailable-item special">
										<div class="title"><BaseCmsLabel code="leanpay_shipping_note" tag="strong" /></div>
										<div class="btn-hidde" @click="hiddeErrorMessage()">
											<span><BaseCmsLabel code="hidde_error" /></span>
										</div>
									</div>

									<WebshopShippingMerge :data="cart" />
									<WebshopPackage :shipping="true" />
								</div>

								<WebshopSidebar :meta="meta" mode="total_full" />
								<WebshopWidgetFixedbar :meta="meta" mode="total_full" />
							</div>
						</form>
					</BaseWebshopCart>
					<template #fallback>
						<BaseThemeUiLoading />
					</template>
				</ClientOnly>
			</WebshopCheckout>
		</CmsCheckoutWrapper>
	</BaseCmsPage>
</template>

<script setup>
	import {useForm} from 'vee-validate';

	const webshop = useWebshop();
	const auth = useAuth();
	const apiRoutes = useApiRoutes();
	const cartData = computed(() => webshop.getCartData());
	const { shippingLeanpayError, formValid, selectedShipping } = useCheckout();
	const gtm = useGtmBB();

	function onPageLoad(data) {
		if(!data) return;
		gtm.pageView({
			url: data?.url || '',
			title: data?.title || '',
		});
	}

	// watch if form is valid
	const { meta } = useForm();
	watch(
		() => meta,
		() => formValid.value = (meta.value.valid) ? 1 : 0,
		{deep: true}
	)

	// redirect to cart page if there are errors in cart
	if (cartData.value?.cart?.errors?.cart?.length) {
		setTimeout(async () => {
			await navigateTo(apiRoutes.getAppUrl('webshop_shopping_cart'));
		}, 1000);
	}

	// redirect to cart page if there are warnings in cart
	if (cartData.value?.cart?.warnings?.cart?.length) {
		setTimeout(async () => {
			await navigateTo(apiRoutes.getAppUrl('webshop_shopping_cart'));
		}, 1000);
	}

	//hidde error message
	function hiddeErrorMessage() {
		shippingLeanpayError.value = 0;
	};

	//on submit
	async function onSubmit() {
		await gtm.addShippingInfo({
			'shippingOption': selectedShipping.value
		});
		await navigateTo(apiRoutes.getAppUrl('webshop_review_order'));
	}
</script>
